import { render, staticRenderFns } from "./VDealsRandom.vue?vue&type=template&id=015ebee0&"
import script from "./VDealsRandom.vue?vue&type=script&lang=js&"
export * from "./VDealsRandom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('015ebee0')) {
      api.createRecord('015ebee0', component.options)
    } else {
      api.reload('015ebee0', component.options)
    }
    module.hot.accept("./VDealsRandom.vue?vue&type=template&id=015ebee0&", function () {
      api.rerender('015ebee0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/VDealsRandom/VDealsRandom.vue"
export default component.exports